import React from 'react';
import styled from 'styled-components';

export const DelaySummary = ({ details, serviceabilityUrl = '' }) => {
  if (!details) return null;
  const { post_pickup, pre_pickup } = details;
  return (
    <DelaySummary.Wrapper className='modalContent'>
      <DelaySummary.Content>
        <p className='dark semiBold large'>{pre_pickup?.titleETA}</p>
        {pre_pickup?.listETA?.map((item, index) => {
          return (
            <DelaySummary.List
              key={index}
              style={{
                backgroundColor: item.bg_color,
                borderColor: item.border_color,
                color: item.color,
              }}
            >
              <DelaySummary.Icon src={item.icon} alt=''></DelaySummary.Icon>
              {item.title}
            </DelaySummary.List>
          );
        })}
        <br></br>
        <p className='dark semiBold large'>{pre_pickup?.title}</p>
        {pre_pickup?.list?.map((item, index) => {
          return (
            <DelaySummary.List
              key={index}
              style={{
                backgroundColor: item.bg_color,
                borderColor: item.border_color,
                color: item.color,
              }}
            >
              <DelaySummary.Icon src={item.icon} alt=''></DelaySummary.Icon>
              {item.title}
            </DelaySummary.List>
          );
        })}
      </DelaySummary.Content>
      <DelaySummary.Content>
        <p className='dark semiBold large'>{post_pickup?.title}</p>
        {post_pickup?.list?.map((item, index) => {
          return (
            <DelaySummary.List
              key={index}
              style={{
                backgroundColor: item.bg_color,
                borderColor: item.border_color,
                color: item.color,
              }}
            >
              <DelaySummary.Icon src={item.icon} alt=''></DelaySummary.Icon>
              {item.title}
            </DelaySummary.List>
          );
        })}
      </DelaySummary.Content>
      {serviceabilityUrl && (
        <a
          href={serviceabilityUrl}
          target='_blank'
          css={`
            color: rgb(83, 156, 238);
          `}
          rel='noreferrer'
        >
          <strong>Go To Serviceability Dashboard</strong>
        </a>
      )}
    </DelaySummary.Wrapper>
  );
};

DelaySummary.Wrapper = styled.div``;

DelaySummary.Content = styled.div`
  margin-bottom: 4rem;
`;

DelaySummary.List = styled.div`
  margin-top: 1.8rem;
  padding: 1.2rem;
  border: 1px solid;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 8px;
`;

DelaySummary.Icon = styled.img`
  width: 2.5rem;
  margin-right: 1.5rem;
`;
